var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#0C0D0E",
    rx: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 130,
    width: 110,
    height: 20,
    fill: "#FB569D",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 80,
    height: 20,
    fill: "#7D8C6B",
    rx: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 70,
    width: 50,
    height: 20,
    fill: "#DCCA87",
    rx: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtpLogo);
export default __webpack_public_path__ + "static/media/etp_logo.7b997d2271146b41a8f499809d80c2e5.svg";
export { ForwardRef as ReactComponent };